export const APP_NAME = 'TurboWarp';
